<template>
  <!--    vision-area-start-->
  <div class="vision-area">
    <div class="container">
      <div class="row" v-if="article">
        <div class="col-lg-12">
          <div class="section-title">
            <h3>{{ article.title }}</h3>
            {{ article.subTitle }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-4" v-for="box in boxes" :key="box.id">
          <div :class="classes + 'var2'">
            <div class="team-img">
              <h5 v-html="box.title"></h5>
            </div>
            <div class="team-containt" v-html="box.text"></div>
            <div class="pt-3" v-if="box.buttonLink">
              <router-link :to="box.buttonLink"
                >{{ box.buttonText }} <i class="far fa-long-arrow-alt-right"></i
              ></router-link>
            </div>
            <div class="pt-3" v-else>
              {{ box.buttonText }}
            </div>
          </div>
        </div>
        <!-- <div class="col-lg-4 col-md-4">
          <div class="single-team vision var2">
            <div class="team-img">
              <img src="assets/img/v2.png" alt="" />
            </div>
            <div class="team-containt team-containt-special" v-html="article.textBox"></div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4">
          <div class="single-team vision var2">
            <div class="team-img">
              <img src="assets/img/v2.png" alt="" />
            </div>
            <div class="team-containt team-containt-special" v-html="article.textBox"></div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
  <!--    vision-area-end-->
</template>

<script>
import { getCollection, getArticleById } from '@/api/navItems';
import { translate } from '@/lib/utils';

export default {
  created() {
    getCollection('category-boxes', this.condition).then(res => {
      console.log(this.condition);
      this.boxes = res;
    });
    getArticleById(this.articleId).then(res => {
      this.article = translate(res);
    });
  },
  props: {
    slug: {
      type: String
    },
    articleId: {
      type: String
    },
    condition: {
      type: Object
    },
    classes: {
      type: String,
      default: 'single-team vision '
    }
  },
  data() {
    return {
      article: {},
      boxes: []
    };
  }
};
</script>

<style lang="scss" scoped>
.section-title h3 {
  max-width: 580px;
  margin-left: auto;
  margin-right: auto;
}

.section-title p {
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.icon-colors {
  background: red;
}
</style>
